<template>
  <div id="pProjectDetail" :class="pageClass" v-if="item.thumb">
    <Nav type="transparent" />
    <span class="pageTitle" v-html="pageTitle"></span>
    <div class="pContent">
      <div class="blockTit" v-html="item.name"></div>
      <div class="detailTop" style="margin-bottom: 64px;">
        <div class="pd-img">
          <img :src="require(`@/assets/${item.thumb}`)" alt />
        </div>
        <div>
          <p class="blockText" style="letter-spacing: -0.2px;">
            {{ item.intro }}
            <mu-icon
              class="mIcon"
              v-if="item.priceInfo"
              size="16"
              value="info_outline"
              @click="table = true"
            ></mu-icon>
          </p>
          <ul class="pdInfo">
            <li>
              <div>项目时间</div>
              <div class="con" v-html="item.time"></div>
            </li>
            <li>
              <div>项目价格</div>
              <div class="con" :class="{ link: item.priceBtn }" @click="item.priceBtn && (table = true)">
                <span v-html="item.price"></span>
                <div
                  class="showListBtn"
                  @click="toggleShowList"
                  v-if="item.priceList || item.multyPriceList"
                >
                  <span>会员价格</span>
                  <span class="icon" :class="{ active: showList }">&or;</span>
                </div>
              </div>
            </li>
            <template v-if="item.multyPriceList">
              <li v-for="(n, i) in item.multyPriceList" :key="i" v-show="showList">
                <div></div>
                <div class="con">
                  <span v-if="n.type != 'tag'" :class="`priceIcon ${n.type}`"></span>
                  <span class="priceName" v-if="n.type == 'level1'">VIP卡</span>
                  <span class="priceName" v-if="n.type == 'level2'"
                    >明星卡</span
                  >
                  <span class="priceName" v-if="n.type == 'level3'"
                    >钻石卡</span
                  >
                  <span class="tag" v-for="(v, ni) in n.value" :key="i+'-'+ni" v-html="(n.type == 'tag' ? '' : '¥') + `${v}`"></span>
                </div>
              </li>
            </template>
            <template v-if="item.priceList">
              <li v-for="(n, i) in item.priceList" :key="i" v-show="showList">
                <div></div>
                <div class="con">
                  <span :class="`priceIcon ${n.type}`"></span>
                  <span class="priceName" v-if="n.type == 'level1'">VIP卡</span>
                  <span class="priceName" v-if="n.type == 'level2'"
                    >明星卡</span
                  >
                  <span class="priceName" v-if="n.type == 'level3'"
                    >钻石卡</span
                  >
                  <span v-html="`¥${n.value}`"></span>
                </div>
              </li>
            </template>
            <li>
              <div>项目部位</div>
              <div class="con" v-html="item.position"></div>
            </li>
            <li>
              <div>项目亮点</div>
              <div class="con" v-html="item.title"></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="index-banner" v-if="item.sliderP">
        <div class="mid-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(n, i) in item.sliderP" :key="'sliderP'+i">
              <img :src="require(`@/assets/${n}`)" alt />
              <div v-if="item.sliderInnerTextP" class="textbox" v-html="item.sliderInnerTextP[i]"></div>
            </div>
          </div>
          <div class="mid-pagination"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <div class="step clearfix" v-for="(n, i) in item.points" :key="i">
        <p class="blockTit">
          <span v-html="n.name"></span>
        </p>
        <p class="blockText" v-html="n.text"></p>
        <img :src="require(`@/assets/${n.thumb}`)" alt />
      </div>
    </div>

    <mu-dialog title class="table" width="800" :open.sync="table">
      <i class="close" @click="table = false"></i>
      <div class="imgBox" v-if="item.priceInfo">
        <img :src="item.priceInfo.p" alt />
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import data from '@/utils/projectData.js';

export default {
  name: 'pProjectDetail',
  data() {
    return {
      item: {},
      pageClass: '',
      pageTitle: '',
      showList: false,
      table: false,
    };
  },
  components: {
    Nav,
  },
  computed: {},
  watch: {
    '$route.params.id'(t) {
      this.getData();
    },
  },
  methods: {
    getData() {
      let list,
        type,
        that = this;
      switch (this.$route.params.type) {
        case '1':
          type = 'skin';
          break;
        case '2':
          type = 'head';
          break;
        case '3':
          type = 'body';
          break;
        case '4':
          type = 'face';
          break;
        default:
          type = 'skin';
      }
      this.pageClass = data[type].pageClass;
      this.pageTitle = data[type].pageTitle;
      list = data[type].data;
      list.forEach((n) => {
        if (n.id == that.$route.params.id) {
          that.item = n;
        }
      });
    },
    initMswiper() {
      new Swiper('.mid-container', {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.mid-pagination',
          clickable: true,
        },
      });
    },
    toggleShowList() {
      this.showList = !this.showList;
    },
  },
  mounted() {
    this.getData();
    this.$nextTick(() => {
      this.initMswiper();
    });
  },
};
</script>

<style lang="scss" scoped>
#pProjectDetail {
  padding: 350px 0 140px;
  background: url(../assets/pProject-banner.jpg) top/auto 350px no-repeat;

  &.project1 {
    background-image: url(../assets/pProject-banner.jpg);
  }
  &.project2 {
    background-image: url(../assets/pProject-banner2.jpg);
  }
  &.project3 {
    background-image: url(../assets/pProject-banner3.jpg);
  }
  &.project4 {
    background-image: url(../assets/pProject-banner4.jpg);
  }

  .pContent {
    margin: 0 auto;
    width: 90%;
    max-width: 830px;
  }
  .blockTit {
    margin: 90px 0 28px;
    font-size: 18px;
    line-height: 26px;
    text-align: left;
  }
  .blockText {
    font-size: 14px;
    line-height: 24px;
    text-align: left;
  }
  .project-banner {
    position: relative;
    overflow: hidden;
  }
  .detailTop {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    > div:last-child {
      flex: 1;
      margin-left: 32px;
    }
  }
  .pd-img {
    // float: left;
    width: 270px;
    > img {
      display: block;
      width: 100%;
    }
  }

  .pdInfo {
    margin-top: 20px;
    border-bottom: 1px solid #e6e6e6;
    > li {
      display: flex;
      justify-content: space-between;
      min-height: 64px;
      border-top: 1px solid #e6e6e6;
      // > span {
      //     font-size: 14px;
      //     line-height: 64px;
      //     color: #313131;
      //     &:last-child {
      //         float: right;
      //         // font-weight: bold;
      //         font-size: 18px;
      //     }
      // }
      > div {
        display: flex;
        align-items: center;
        padding: 12px 0;
        font-size: 14px;
        line-height: 22px;
        color: #313131;
        &:first-child {
          flex-shrink: 0;
          margin-right: 32px;
        }
        &.con {
          display: flex;
          // flex-direction: column;
          // justify-content: center;
          align-items: center;
          font-weight: 400;

          span {
            font-weight: 400;
          }
          &.link {
            span {
              border-bottom: 1px solid #313131;
              cursor: pointer;
            }
          }
          .priceIcon {
            display: inline-block;
            width: 40px;
            height: 44px;
            background: left/36px 22px no-repeat;
            &.level1 {
              background-image: url(../assets/priceIcon1.png);
            }
            &.level2 {
              background-image: url(../assets/priceIcon2.png);
            }
            &.level3 {
              background-image: url(../assets/priceIcon3.png);
            }
          }
          .priceName {
            display: inline-block;
            padding-right: 15px;
            width: 70px;
            text-align: right;
            & + span {
              width: 44px;
              text-align: right;
            }
          }

          .tag {
            width: 90px!important;
            text-align: center!important;
          }
        }
      }
    }
  }
  .showListBtn {
    display: inline-flex;
    justify-content: center;
    margin-left: 5px;
    width: 96px;
    height: 36px;
    // font-size: 14px;
    line-height: 36px;
    background: #d7caaa;
    cursor: pointer;

    .icon {
      margin-left: 8px;
      transform: rotate(180deg) scale(1, 0.45);
      transition: all 0.3s;
      &.active {
        transform: rotate(360deg) scale(1, 0.45);
      }
    }
  }
  .step {
    margin: 0 auto 24px;
    height: 150px;
    > p:first-child {
      display: flex;
      flex-direction: row;
      float: left;
      margin: 0;
      width: 16.8%;
      height: 100%;
      line-height: 150px;
      @media (max-width: 768px) {
        width: 10.5%;
      }

      > span {
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 24px;
      }
    }
    > p:nth-child(2) {
      float: left;
      margin-left: 30px;
      padding: 50px 0;
      width: 420px;
      height: 150px;
    }

    > img {
      float: right;
      height: 150px;
    }
    .blockText {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
  }
}
.mid-container {
  padding-bottom: 70px;
  .swiper-slide {
    // width: 540px;
    img {
      display: block;
      width: 100%;
    }
  }
}
.index-banner .swiper-button-next,
.index-banner .swiper-button-prev {
  top: 180px;
  width: 49px;
  height: 49px;
  background: none;
  transition: all 0.2s;
  outline: 0;
  opacity: 0;
  transform: translateX(50px);
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../assets/pIndex-next.png) no-repeat;
    transition: all 0.3s;
  }
  &:hover::after {
    transform: scale(1.1);
  }
}
.index-banner .swiper-button-prev {
  transform: translateX(-50px);
  &::after {
    background: url(../assets/pIndex-prev.png) no-repeat;
  }
}
// .swiper-wrapper:hover ~ .swiper-button-next,
// .swiper-wrapper:hover ~ .swiper-button-prev {
//     transform: translateX(0);
//     opacity: 1;
// }
.index-banner:hover .swiper-button-next,
.index-banner:hover .swiper-button-prev {
  transform: translateX(0);
  opacity: 1;
}
.mIcon {
  position: relative;
  top: 3px;
  color: #d1d1d1;
  cursor: pointer;
}
</style>
<style lang="scss">
#pProjectDetail {
  .textbox {
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    position: absolute;
    left: 300px;
    top: 54px;
    width: 440px;
    height: 300px;

    p {
      margin: 0;
      display: flex;
      > span:last-child {
        flex: 1;
      }

      &.st1 {
        font-weight: 500;
        font-size: 40px;
        line-height: 56px;
        color: #333;
      }
      &.st2 {
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        text-align: left;
      }
      &.st3 {
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        text-align: left;
      }
    }
  }
}
</style>
